import React from 'react';
import { Section } from '@atlaskit/side-navigation';
import { AddObjectTypeButton } from './add-object-type-button/index.tsx';
import { ObjectTypeTree } from './object-type-tree/index.tsx';

export const SidebarContent = () => {
	return (
		<Section>
			<ObjectTypeTree />
			<AddObjectTypeButton />
		</Section>
	);
};
